import { render, staticRenderFns } from "./o_klent.vue?vue&type=template&id=2bd00cf5&scoped=true&"
import script from "./o_klent.vue?vue&type=script&lang=js&"
export * from "./o_klent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd00cf5",
  null
  
)

export default component.exports